module.exports = __webpack_public_path__ + "static/media/taka.b6a333fe.svg";